import Margin from './margin';

/**
 * Dims is short for Dimensions lol
 */
export default class Dims {
  private _h = 400;
  private _w = 500;

  constructor(h?: number, w?: number) {
    if (h) this._h = h;
    if (w) this._w = w;
  }

  public height() {
    return this._h;
  }

  public width() {
    return this._w;
  }

  public setHeight(h: number) {
    this._h = h;
  }

  public setWidth(w: number) {
    this._w = w;
  }

  /**
   * Returns both height and width
   */
  public both() {
    const height = this.height();
    const width = this.width();
    return { height, width };
  }

  /**
   * Returns height and width with respect to a margin instance
   * @param mar
   * @returns
   */
  public marDims(mar: Margin) {
    const height = this.height() - mar.top - mar.bottom;
    const width = this.width() - mar.left - mar.right;

    return { height, width };
  }
}
